export default __webpack_public_path__ + "static/media/brand1.8b371a8f.svg";